import * as actions from './mining.actions'

const initialState = {
  currentScreen: 'mining_default',
  prevScreen: null,
  signal: false,
  countDisputes: 0,
  ownQuestions: [],
  disputedQuestions: [],
  debatedQuestions: [],
  disputes: [],
}

const actionsMap = {
  [actions.CHANGE_MINING_SCREEN]: (state, action) => {
    const newScreen = action.data
    // const lastScreen = state.currentScreen

    return {
      ...state,
      currentScreen: newScreen,
      prevScreen: state.prevScreen != newScreen ? 'mining_default' : state.prevScreen,
    }
  },
  [actions.REMOVE_PREV_SCREEN]: (state) => {
    return {
      ...state,
      prevScreen: null,
    }
  },
  [actions.SET_NEW_SIGNAL]: (state, action) => {
    const signal = action.data

    return {
      ...state,
      signal: signal,
    }
  },
  [actions.GET_COUNT_DISPUTES_SUCCESS]: (state, action) => {
    const data = action.data
    return {
      ...state,
      countDisputes: data.total,
    }
  },
  [actions.GET_COUNT_DISPUTES_ERROR]: (state) => {
    return {
      ...state,
      countDisputes: 0,
    }
  },
  [actions.GET_OWN_QUESTIONS_SUCCESS]: (state, action) => {
    const { createdQuestions, disputedQuestions, debatedQuestions } = action.data
    return {
      ...state,
      ownQuestions: createdQuestions,
      disputedQuestions,
      debatedQuestions,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
